import { render, staticRenderFns } from "./CanvasWindow.vue?vue&type=template&id=779b87b5&scoped=true"
import script from "./CanvasWindow.vue?vue&type=script&lang=ts"
export * from "./CanvasWindow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b87b5",
  null
  
)

export default component.exports